import { userAccessIds } from "./configs/userAccess";
import screens from "./screens";
import backofficeChallenges from "./store/challenges/challengesSlice";
import backofficeNavigationTips from "./store/navigationTips/navigationTipsSlice";

export default {
  screens,
  reducers: {
    backofficeChallenges,
    backofficeNavigationTips,
  },
  userAccessIds,
};
